import { Button, Drawer, Space, Spin } from "antd";
import { AiOutlineClose, AiOutlinePrinter } from "react-icons/ai";
import DocumentWrapper from "../../../components/docum/DocumentWrapper";
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef, useState } from "react";
import splitChunks from "../../../utils/splitChunks";

export default function Document({
  isVisible,
  setVisible,
  selected,
  claim,
}: any) {
  const [isLoading] = useState(false);
  const [statements, setStatements] = useState<any>([]);
  const [allTransaction, setTransactions] = useState<any>([]);

  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const handleFetchStatements = async () => {
    const data = claim?.items;
    const chunks = splitChunks(data, 17);
    setTransactions(data);
    setStatements(chunks);
  };


  useEffect(() => {
    handleFetchStatements();
  }, [selected]);

  const getTotalDue = () => {
    let total = 0;

    allTransaction.forEach((item: any) => {
      total = total + item.outstanding;
    });
    return total;
  };

  return (
    <Drawer
      title={`Expense Claim`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button type="default" onClick={() => setVisible(!isVisible)} danger>
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div>
        <div className="flex flex-row justify-center items-center">
          <div className="flex justify-between items-center border-b h-12 w-full -mt-6">
            <div className=""></div>
            <div className="border border-gray-300 p-2 rounded-sm">
              <button
                onClick={() => reactToPrintFn()}
                className="flex justify-center border p-2 items-center focus:outline-none  mr-2 text-sm hover:text-toyota"
              >
                <AiOutlinePrinter className="mr-1" /> Print
              </button>
            </div>
          </div>
        </div>
        <div className="flex flex-row bg-whitish  justify-center items-start overflow-auto">
          <div className="bg-white px-4">
            {isLoading ? (
              <div className="">
                <Spin />
              </div>
            ) : (
              <div className="">
                <div className="book" ref={contentRef}>
                  {statements?.map((page: any, index: number) => (
                    <div className="page" key={index}>
                      <div className="subpage">
                        <DocumentWrapper
                          statements={page}
                          selected={selected}
                          pageno={index + 1}
                          pages={statements.length}
                          getTotalDue={getTotalDue}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
